import { useAppContext } from 'components/Core/Base';
import { AnalyticsDashboard, SetupDashboard } from 'components/Dashboard';

export const Dashboard = () => {

    const { context } = useAppContext();

    return context?.hasAccounts && context.hasEnvironments && context.hasPhoneNumbers ? (<AnalyticsDashboard />) : (<SetupDashboard />)
}